exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clicked[data-v-72693a7a],.disabled[data-v-72693a7a],.locked[data-v-72693a7a]{border-color:#ededed;background:#ededed!important;cursor:not-allowed;color:#fff}.clicked[data-v-72693a7a]:focus,.clicked[data-v-72693a7a]:hover,.disabled[data-v-72693a7a]:focus,.disabled[data-v-72693a7a]:hover,.locked[data-v-72693a7a]:focus,.locked[data-v-72693a7a]:hover{border-color:#ededed}", ""]);

// exports
